'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiSocialYoutube = function TiSocialYoutube(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm38 14.3c-0.3-2.5-0.7-4.3-1.7-5-1-0.8-9.6-1-16.3-1s-15.3 0.2-16.3 1c-1 0.7-1.4 2.5-1.7 5s-0.3 4-0.3 5.7 0 3.2 0.3 5.7 0.7 4.3 1.7 5c1 0.8 9.6 1 16.3 1 6.7 0 15.3-0.2 16.3-1 1-0.7 1.4-2.5 1.7-5s0.3-4 0.3-5.7 0-3.2-0.3-5.7z m-21.3 11.7v-12l10 6-10 6z' })
        )
    );
};

exports.default = TiSocialYoutube;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/social-youtube.js
// module id = 2026
// module chunks = 0